/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Runtime information of a pipeline task executor.
 * @export
 * @interface V2beta1PipelineTaskExecutorDetail
 */
export interface V2beta1PipelineTaskExecutorDetail {
  /**
   * The name of the job for the main container execution.
   * @type {string}
   * @memberof V2beta1PipelineTaskExecutorDetail
   */
  main_job?: string;
  /**
   * The name of the job for the pre-caching-check container
   * execution. This job will be available if the
   * Run.pipeline_spec specifies the `pre_caching_check` hook in
   * the lifecycle events.
   * @type {string}
   * @memberof V2beta1PipelineTaskExecutorDetail
   */
  pre_caching_check_job?: string;
  /**
   * The names of the previously failed job for the main container
   * executions. The list includes the all attempts in chronological order.
   * @type {Array<string>}
   * @memberof V2beta1PipelineTaskExecutorDetail
   */
  failed_main_jobs?: Array<string>;
  /**
   * The names of the previously failed job for the
   * pre-caching-check container executions. This job will be available if the
   * Run.pipeline_spec specifies the `pre_caching_check` hook in
   * the lifecycle events.
   * The list includes the all attempts in chronological order.
   * @type {Array<string>}
   * @memberof V2beta1PipelineTaskExecutorDetail
   */
  failed_pre_caching_check_jobs?: Array<string>;
}

/**
 * Check if a given object implements the V2beta1PipelineTaskExecutorDetail interface.
 */
export function instanceOfV2beta1PipelineTaskExecutorDetail(
  value: object,
): value is V2beta1PipelineTaskExecutorDetail {
  return true;
}

export function V2beta1PipelineTaskExecutorDetailFromJSON(
  json: any,
): V2beta1PipelineTaskExecutorDetail {
  return V2beta1PipelineTaskExecutorDetailFromJSONTyped(json, false);
}

export function V2beta1PipelineTaskExecutorDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PipelineTaskExecutorDetail {
  if (json == null) {
    return json;
  }
  return {
    main_job: json['main_job'] == null ? undefined : json['main_job'],
    pre_caching_check_job:
      json['pre_caching_check_job'] == null ? undefined : json['pre_caching_check_job'],
    failed_main_jobs: json['failed_main_jobs'] == null ? undefined : json['failed_main_jobs'],
    failed_pre_caching_check_jobs:
      json['failed_pre_caching_check_jobs'] == null
        ? undefined
        : json['failed_pre_caching_check_jobs'],
  };
}

export function V2beta1PipelineTaskExecutorDetailToJSON(
  json: any,
): V2beta1PipelineTaskExecutorDetail {
  return V2beta1PipelineTaskExecutorDetailToJSONTyped(json, false);
}

export function V2beta1PipelineTaskExecutorDetailToJSONTyped(
  value?: V2beta1PipelineTaskExecutorDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    main_job: value['main_job'],
    pre_caching_check_job: value['pre_caching_check_job'],
    failed_main_jobs: value['failed_main_jobs'],
    failed_pre_caching_check_jobs: value['failed_pre_caching_check_jobs'],
  };
}
